'use strict';

import faker from 'faker';

export default class Fake {
  cars = [
    {make: 'BMW', model: '5 Series'},
    {make: 'Acura', model: 'MDX'},
    {make: 'Volvo', model: 'S80'},
    {make: 'Kia', model: 'Sorento'},
    {make: 'Buick', model: 'Regal'},
    {make: 'Jeep', model: 'Liberty'}
  ]

  colors = [
    'Red',
    'Green',
    'Blue',
    'Black',
    'Silver',
    'Orange',
    'Gold'
  ]

  constructor() {
    'ngInject';
  }

  getRandom = function(list) {
    return list[Math.floor(Math.random() * list.length)];
  }

  fakeApp() {
    // Create the $http object for this request
    // Initialize Application Data
    let car = this.getRandom(this.cars);
    let application = {
      name: {
        first: faker.name.firstName(),
        last: faker.name.lastName(),
        alt: faker.name.lastName()
      },
      contact: {
        email: faker.internet.email(),
        primaryPhone: faker.phone.phoneNumberFormat().replace(/-/g, ''),
        cellPhone: faker.phone.phoneNumberFormat().replace(/-/g, '')
      },
      address: {
        line1: faker.address.streetAddress(),
        line2: faker.address.secondaryAddress(),
        city: faker.address.city(),
        state: faker.address.stateAbbr(),
        zip: faker.address.zipCode()
      },
      beach: {
        // community: 'OB',
        // type: 'Business',
        name: '12',
        owner: faker.name.findName(),
        walk: faker.address.streetAddress(),
        phone: faker.phone.phoneNumberFormat().replace(/-/g, '')
      },
      vehicle: {
        year: faker.date.past().getFullYear(),
        make: car.make,
        model: car.model,
        color: this.getRandom(this.colors),
        size: 'Oversized',
        plate: faker.lorem.word().toUpperCase(),
        card: Math.floor(Math.random() * (9999 - 199 + 1)),
        state: faker.address.stateAbbr()
      },
      agreement: true
    };
    return application;
  }

}



// WEBPACK FOOTER //
// ./client/components/services/fake.service.js